module.exports = __webpack_public_path__ + "img/icon_manual_team.de31998d.png";